/** Browser identity sent with every API call so the Admin can see who is on which device.
 *  Browsers cannot read the Windows computer name; the user may type one on the login screen. */

const ID_KEY = 'ashr_device_id';
const NAME_KEY = 'ashr_device_name';

const uuid = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `d-${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}`;
};

export const deviceId = () => {
  let id = localStorage.getItem(ID_KEY);
  if (!id) {
    id = uuid();
    localStorage.setItem(ID_KEY, id);
  }
  return id;
};

const fromUa = () => {
  const ua = navigator.userAgent || '';
  let browser = 'Browser';
  if (ua.includes('Edg/')) browser = 'Edge';
  else if (ua.includes('Chrome/') && !ua.includes('Chromium')) browser = 'Chrome';
  else if (ua.includes('Firefox/')) browser = 'Firefox';
  else if (ua.includes('Safari/') && !ua.includes('Chrome/')) browser = 'Safari';
  let os = 'device';
  if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Android')) os = 'Android';
  else if (/iPhone|iPad/.test(ua)) os = 'iOS';
  else if (/Mac OS|Macintosh/.test(ua)) os = 'Mac';
  else if (ua.includes('Linux')) os = 'Linux';
  return `${browser} on ${os}`;
};

export const deviceName = () => (localStorage.getItem(NAME_KEY) || '').trim() || fromUa();

export const setDeviceName = (name) => {
  const v = String(name || '').trim().slice(0, 120);
  if (v) localStorage.setItem(NAME_KEY, v);
  else localStorage.removeItem(NAME_KEY);
  return deviceName();
};

export const savedDeviceName = () => (localStorage.getItem(NAME_KEY) || '').trim();

export const deviceHeaders = () => ({
  'X-ASHR-Device-Id': deviceId(),
  'X-ASHR-Device-Name': deviceName(),
});
